<template>
  <CVButton class="back-button group" variant="link" @click.prevent="handleBack">
    <ArrowLeftIcon class="h-5 w-5" />
    <span v-if="!$slots.default">{{ t('back') }}</span>
    <slot></slot>
  </CVButton>
</template>

<script setup lang="ts">
import { ArrowLeftIcon } from '@heroicons/vue/24/outline';
import { useI18n } from 'vue-i18n';
import { useRouter, type RouteLocationNamedRaw } from 'vue-router';

const props = defineProps<{
  to?: RouteLocationNamedRaw;
  fallback?: RouteLocationNamedRaw;
}>();

const router = useRouter();
const { t } = useI18n();

function handleBack() {
  if (props.to) {
    void router.push(props.to);
    return;
  }
  if (window.history.state?.back != null) {
    router.go(-1);
    return;
  }
  if (props.fallback) {
    void router.push(props.fallback);
  }
}
</script>

<style scoped>
[data-theme='carvia'] .back-button.btn.btn-primary.btn-outline {
  @apply border border-transparent bg-accent text-primary;
}
[data-theme='carvia'] .back-button.btn.btn-primary.btn-outline:hover {
  @apply border-primary bg-transparent text-primary;
}
.arrow-long-left {
  @apply relative block h-[6px] w-[14px] scale-90 border-b-[2px] border-t-[2px] border-b-transparent border-t-transparent text-primary shadow-[inset_0_0_0_2px] before:absolute before:-bottom-[2px] before:left-0 before:block before:h-[6px] before:w-[6px] before:rotate-[45deg] before:border-b-[2px] before:border-l-[2px] before:border-primary before:content-[''];
}
</style>
